import style from './style.module.css';
import { Col, Row } from 'antd';
import { Empty, Select } from 'fave-ui';
import { PageHeaderWithBackButton } from '../../components/common/PageHeaderWithBackButton';
import { useState } from 'react';
import RenderRefundForm from './RenderRefundForm';
import { useFetchManualRefundFormFields } from '../../services/ManualRefund/useFetchFormFields';
import SpinOverlay from '../../components/common/SpinOverlay/Spin';

export default function ManualRefund() {
  const [paymentType, setPaymentType] = useState('');

  const { data: refundFields, isLoading } = useFetchManualRefundFormFields();

  const fields =
    refundFields?.payment_type_details[
      paymentType as keyof typeof refundFields.payment_type_details
    ];

  if (isLoading || !refundFields) {
    return <SpinOverlay />;
  }

  return (
    <>
      <PageHeaderWithBackButton title={`Manual Refund`} />
      <Row>
        <Col span={24}>
          <p className={style.label}>* Payment Type</p>
          <Select
            placeholder="Please Select Payment Type"
            options={Object.keys(refundFields.payment_type_details).map(
              key => ({ label: key, value: key, key: key }),
            )}
            onChange={e => setPaymentType(e)}
            className={style.paymentType}
          />
        </Col>
        {fields ? (
          <RenderRefundForm paymentType={paymentType} fields={fields} />
        ) : (
          <Col span={24}>
            <Empty customTitle="Please select a Payment Type to continue" />
          </Col>
        )}
      </Row>
    </>
  );
}
